import React from 'react';

import { Flex } from '@rover/kibble/core';
import StyledDateRangePicker, {
  Props as StyledDateRangePickerProps,
} from '@rover/react-lib/src/pages/landing/components/StyledDateRangePicker';
import type { DateHooks } from '@rover/react-lib/src/pages/landing/utilities/useDates';
import type { UpdatedDateRange } from '@rover/types/src/datetime/DateRange';

export type Props = StyledDateRangePickerProps & DateHooks;
const DateRangePicker = (props: Props): JSX.Element => {
  const { startPlaceholder, endPlaceholder, inline, setStartDate, setEndDate, onChange } = props;

  return (
    <Flex
      flexDirection={inline ? 'row' : 'column'}
      alignItems={inline ? 'center' : 'stretch'}
      width={inline ? '100%' : 'auto'}
    >
      <StyledDateRangePicker
        {...props}
        startPlaceholder={startPlaceholder}
        endPlaceholder={endPlaceholder}
        onChange={(dateRange?: UpdatedDateRange | null): void => {
          if (dateRange) {
            setStartDate(dateRange.startDate);
            setEndDate(dateRange.endDate);
            onChange(dateRange);
          }
        }}
      />
    </Flex>
  );
};

export default DateRangePicker;
